"use client";

import React from "react";

import ContextInternal from "@/context/Internal";
import UiMessageError from "@/components/Ui/Message/Error";

export default function ErrorPage() {
  return (
    <ContextInternal>
      <UiMessageError errorTitle="Error" errorCode={404} errorDescription="The page you are looking for could not be found." />
    </ContextInternal>
  );
}
